const TARGET_URL = "get_cart_details";

const originalOpen = XMLHttpRequest.prototype.open;
const originalSend = XMLHttpRequest.prototype.send;

XMLHttpRequest.prototype.open = function (method, url, ...rest) {
  this._intercept = url.includes(TARGET_URL);
  this._url = url;
  return originalOpen.call(this, method, url, ...rest);
};

XMLHttpRequest.prototype.send = function (body) {
  if (this._intercept) {
    this.addEventListener("load", function () {
      try {
        const json = JSON.parse(this.responseText);
        json?.discounts?.cart?.items?.forEach((cartItem) => {
          const cartItemFinalPrice = cartItem.original_line_price_format;
          const cartItemQuantity = parseInt(cartItem.quantity);
          const cartItemOnlyNumbers = cartItemFinalPrice.replace(/\D/g, "");
          const cartItemPriceWithOptions =
            cartItemOnlyNumbers / cartItemQuantity;
          const cartItemPriceFormatted = new Intl.NumberFormat(Shopify.locale, {
            style: "currency",
            currency: Shopify.currency.active,
          }).format(cartItemPriceWithOptions / 100);
          document.querySelector(
            `[data-hulkapps-custom-price][data-key="${cartItem.key}"]`
          ).textContent = cartItemPriceFormatted;
        });
      } catch (e) {
        console.warn("HULK CUSTOM: Failed to edit prices");
      }
    });
  }
  return originalSend.call(this, body);
};
